import { Button, notification, Tooltip } from 'antd';
import { Footer, Item, Key, Value, ValueCapitalized } from './styled';
import { Head, Title } from 'shared/styled/styled';
import { useSelector } from 'react-redux';
import selectors from 'redux/selectors/selectors';
import { getUiDateShort } from 'shared/lib/dates';
import { useState } from 'react';
import { getStripeUrl } from 'redux/actions/eCommerceActions';

export function BlockCurrentPlan() {
  const accountInfo = useSelector(selectors.accountInfo);
  const usage = useSelector(selectors.usage);
  const subscriptionRenewalDate = useSelector(selectors.subscriptionRenewalDate);
  const planName = useSelector(selectors.planName);
  const [isLoading, setIsLoading] = useState(false);

  const handleSignup = () => {
    setIsLoading(true);
    getStripeUrl()
      .then((request) => {
        window.open(request.url, '_blank');
      })
      .catch((e) => {
        notification.error({
          key: 'response.id',
          message: 'Error occurred',
          description: e.message,
        });
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <div>
        <Head>
          <Title>Plan</Title>
        </Head>
        <Item>
          <Key>Account ID</Key>
          <Value>
            <Value>{accountInfo?.id}</Value>
          </Value>
        </Item>
        <Item>
          <Key>Current Plan</Key>

          <Value>
            <ValueCapitalized>{planName}</ValueCapitalized>
          </Value>
        </Item>
        <div>
          <Item>
            <Key>Sites</Key>
            <Value>
              <Tooltip
                title="Used/Limit"
                placement="top">
                {usage.sites_usage}/{usage.sites_limit}
              </Tooltip>
            </Value>
          </Item>
          <Item>
            <Key>SMS</Key>
            <Value>
              <Tooltip
                title="Used/Limit"
                placement="top">
                {usage.sms_usage}/{usage.sms_limit}
              </Tooltip>
            </Value>
          </Item>
          <Item>
            <Key>Users</Key>
            <Value>
              <Tooltip
                title="Used/Limit"
                placement="top">
                {usage.users_usage}/{usage.users_limit}
              </Tooltip>
            </Value>
          </Item>
        </div>
        <Item>
          <Key>Renewal Date</Key>
          <Value>{getUiDateShort(subscriptionRenewalDate)}</Value>
        </Item>
        <Footer>
          <Button
            loading={isLoading}
            onClick={handleSignup}
            className="primary">
            Manage Plan
          </Button>
        </Footer>
      </div>
    </>
  );
}
